import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import './VideoURLRenderer.css';

class VideoURLRenderer extends Component {
    // static proptypes = {
    //     children: PropTypes.func.isRequired
    // }
    state = {
        mediaData: null
    }

    componentDidMount() {
        this.updateDataFromProps(this.props)
    }

    componentWillReceiveProps(props) {
        this.updateDataFromProps(props)
    }

    updateDataFromProps = (props) => {

        if (!props)
            return

        const { data = null } = props;

        this.setState({ mediaData: data });
    }

    render() {
        const { mediaData = null } = this.state;
        const { muted = false, playing = true } = this.props;

        if (!mediaData) {
            return null;
        }

        const { UploadFile = "" } = mediaData;

        // console.log("UploadFile " + UploadFile)
        // const CORS_PROXY = "https://radiant-sands-32554.herokuapp.com/"


        const path = UploadFile;
        return (
            // <iframe style={{ overFlow: "hidden" }} frameBorder="none" scrolling="no" ref={this.iframeRef} style={{ width: '100%', height: '100%', WebkitTransform: 'scale(1.01)' }} src={path} sandbox="allow-top-navigation allow-scripts allow-forms allow-same-origin"></iframe>
            <div className='player-wrapper'>
                <ReactPlayer className='react-player' muted={mediaData.muted} loop={mediaData.loop} playing={true} ref={this.iframeRef} url={path} controls={false} style={{ width: '100%', height: '100%' }} />
            </div>
            // <iframe style={{ overFlow: "hidden" }} frameBorder="none" scrolling="no" ref={this.iframeRef} style={{ width: '100%', height: '100%', WebkitTransform: 'scale(1.01)' }} src={path} sandbox="allow-top-navigation allow-scripts allow-forms allow-same-origin"></iframe>
        )
    }
}

export default VideoURLRenderer